import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { TranslateModule } from "@ngx-translate/core";

import { LanguageModule } from "@intocare/language";

import { SearchComponent } from "./search.component";
import { ButtonModule } from "../button/button.module";
import { InputModule } from "../input";

@NgModule({
	imports: [
		CommonModule,
		TranslateModule,
		InputModule,
		// TODO: Add config, See issue https://github.com/angular/angular/issues/48519
		FormsModule,
		LanguageModule,
		ButtonModule,
	],
	declarations: [SearchComponent],
	exports: [SearchComponent],
})
export class SearchModule {}
